// Pure helpers of LeadFollowUpLauncher, in their own file so code that only needs them
// (the call pill's prefetch) doesn't load the follow-up screens.

export const latestTreatmentOf = (lead) => {
    const treatments = lead?.lead_treatments;
    if (!Array.isArray(treatments) || treatments.length === 0) return null;
    return [...treatments].sort((a, b) => new Date(b.updated_at || 0) - new Date(a.updated_at || 0))[0];
};

export const leadDetailUrl = (practiceId, leadId) => `/api/v1/practices/${practiceId}/leads/${leadId}/`;
